// React hooks
import { memo, useCallback, useEffect, useState } from "react";

// Helpers i API servisi
import { validateYup } from "services/forms/validation/validation";




// Tipovi i konstante
import { Errors } from "services/forms/validation/types";
import { CONTACT_IMPORT_FORM_SCHEMA } from "./validation";
import { ContactImportProps } from "./types";

// UI komponente
import { Button } from "ui/components/Button/Button";
import { Loader } from "ui/components/Loader";
import { Modal } from "ui/components/Modal";

import { initialContactImportForm } from "services/api/contacts/consts";
import { ContactImportFormValues } from "services/api/contacts/types";
import { contactImportAPI } from "services/api/contacts/api";

const ContactImportCard: React.FC<ContactImportProps> = (props) => {
  const { show, onClose, onSuccess } = props;
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<ContactImportFormValues>(
    initialContactImportForm
  );

  const [files, setFiles] = useState<File[]>([]);

  useEffect(() => {}, []);

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    const isValid = validateYup(
      formValues,
      CONTACT_IMPORT_FORM_SCHEMA,
      setErrors
    );

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    try {
      var result = await Promise.all(
        files.map(async (file) => {
          await contactImportAPI(file);
        })
      );
      if (result && onSuccess) onSuccess();
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  const handleDocumentUpload = useCallback(
    (files: File[]) => {
      setFiles(files);
    },
    [setFiles]
  );

  return (
    <Modal show={show} onHide={onClose}>
      <div className="flex gap-4">
        <div className="h-full w-full  m-auto">
          <div className="space-y-3">
            <div className="py-5 px-5 flex items-center mb-8 border-b border-slate-200 pb-[-1px]">
              <p className="text-base font-semibold text-slate-600">
                Import kontakata
              </p>
            </div>
            <form noValidate className="text-left">
              <div className="px-5 mb-2">
                <div className="mb-3">
                  {/* <FileDropZone onChange={handleDocumentUpload} /> */}
                </div>
              </div>
              <div className="px-5 pb-5 flex justify-end ">
                <Button
                  variant="primary"
                  size="full"
                  children="Spremi"
                  onClick={handleFormSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <Loader isLoading={isLoading ?? false}> </Loader>
    </Modal>
  );
};
export default memo(ContactImportCard);
